import template from './commercial-total-area.jade';
import validation from './../../../services/validation';

export default angular
  .module('cian.addForm.commercialTotalArea', [])
  .directive('cianAfAboutObjectCommercialTotalArea', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService) {
      'ngInject';

      this.isMobile = deviceService.isMobile;

      this.areaMax = 10000000;
      this.areaMin = 0;

      this.validation = validation(this.form, 'totalArea', {
        parse: 'Введите число',
        required: 'Укажите общую площадь',
        min: 'Площадь должна быть больше 0',
        max: 'Допустимо не более 7 символов',
      });
    },
    controllerAs: 'commercialTotalArea',
    template,
  })).name;
